import { render, staticRenderFns } from "./DirectContactModal.vue?vue&type=template&id=6247d97c&scoped=true&"
import script from "./DirectContactModal.vue?vue&type=script&lang=js&"
export * from "./DirectContactModal.vue?vue&type=script&lang=js&"
import style0 from "./DirectContactModal.vue?vue&type=style&index=0&id=6247d97c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6247d97c",
  null
  
)

export default component.exports